import { useTranslate } from '@ur-solutions/react-hooks'
import { AddonButton } from './AddonCell'
import styled from 'styled-components'

const TextAndAction = styled.div<{ border?: boolean }>`
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  border-radius: ${props => props.theme.standardBorderRadius};
  border: ${props =>
    props.border ? `1px solid ${props.theme.colors.gray9}` : 'none'};
  background-color: ${props => props.theme.colors.white};

  & > *:first-child {
    border-right: 1px solid ${props => props.theme.colors.gray9};
    margin-right: 1rem;
    padding-right: 1rem;
  }
  & > *:last-child {
    cursor: pointer;
  }
`

export const AddonTextAndAction: React.FC<{
  canEdit?: boolean
  border?: boolean
  restrictWidth?: boolean
  hideText?: boolean
  onClick?: () => void

  userId: string
  datetimeStart: Date
  datetimeEnd: Date
  addonsAsText: string[]
}> = ({
  canEdit,
  border,
  restrictWidth,
  hideText,
  onClick,
  ...buttonProps
}) => {
  const translations = useTranslate({
    diet: 'salary.addons',
  })

  return (
    <TextAndAction border={border} onClick={onClick}>
      <div>{translations.diet}</div>
      <AddonButton
        {...buttonProps}
        hideText={hideText}
        onClick={onClick}
        restrictWidth={restrictWidth}
      />
    </TextAndAction>
  )
}
